const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { TextControl } = wp.components;
const { useBlockProps, InspectorControls } = wp.blockEditor;
const { PanelBody } = wp.components;

registerBlockType( 'giveasap/giveaway-input', {
    title: __( 'Giveaway Input', 'giveasap' ),
    icon: 'forms',
    category: 'common',
    attributes: {
        label: {
            type: 'string',
            default: __( 'Your Label', 'giveasap' ),
        },
        placeholder: {
            type: 'string',
            default: '',
        },
    },
    edit: ( { attributes, setAttributes } ) => {
        const { label, placeholder } = attributes;
        const blockProps = useBlockProps();

        return (
            <div { ...blockProps }>
                <InspectorControls>
                    <PanelBody title={ __( 'Input Settings', 'giveasap' ) }>
                        <TextControl
                            label={ __( 'Label', 'giveasap' ) }
                            value={ label }
                            onChange={ ( value ) => setAttributes( { label: value } ) }
                        />
                        <TextControl
                            label={ __( 'Placeholder', 'giveasap' ) }
                            value={ placeholder }
                            onChange={ ( value ) => setAttributes( { placeholder: value } ) }
                        />
                    </PanelBody>
                </InspectorControls>
                <div className="giveasap-input-preview">
                    <label>{ label }</label>
                    <input type="text" placeholder={ placeholder } disabled />
                </div>
            </div>
        );
    },
    save: () => {
        return null; // Rendered via PHP or we'll handle it later
    },
} );
